export default class Database {
    public constructor(
        private readonly database: any
    ) {
    }

    public getDatabase(): any {
        return this.database;
    }
}
